<template>
  <div id="vx-row">
    <div class="vx-col w-full w-1/6 sm:w-1/1 md:w-1/1 mb-6"> <!-- vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3 mb-base -->
      <vx-card class="pb-6">
        <div slot="no-body" class="px-6 pt-6">
          <user-edit-tab-account class="mt-4" :data="userData" :user-id="userId" />
        </div>
      </vx-card>
    </div>
    <div class="vx-col w-full w-1/6 sm:w-1/1 md:w-1/1 mb-6">
      <vx-card class="pb-6">
        <div slot="no-body" class="px-6 pt-6">
          <user-settings-change-password />
        </div>
     </vx-card>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import UserEditTabAccount from './UserEditTabAccount.vue'
import UserSettingsGeneral from './UserSettingsGeneral.vue'
import UserSettingsChangePassword from './UserSettingsChangePassword.vue'

export default {
  components: {
    UserEditTabAccount,
    UserSettingsGeneral,
    UserSettingsChangePassword
  },
  data () {
    return {
      activeTab: 0,
      userData: {},
      userId: ''
    }
  },
  computed: mapState(['AppActiveUser']),
  created () {
    if (this.AppActiveUser.uid === 0) {
      this.unsubscribe = this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'UPDATE_USER_INFO') {
          if (state.AppActiveUser !== 0) {
            this.getDetails()
            this.userId = this.AppActiveUser.uid
          }
        }
      })
    } else {
      this.getDetails()
      this.userId = this.AppActiveUser.uid
    }
  },
  beforeDestroy () {
    const unsubscribe = this.$store.subscribe(() => {})
    unsubscribe()
  },
  methods: {
    getDetails () {
      this.$fs.collection('client').doc(this.AppActiveUser.uid).get()
        .then(user => {
          this.userData = user.data()
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
